export enum SendCodeToEmailEventsEnum {
  CONFIRM_EMAIL = 'CONFIRM_EMAIL',
  CONFIRM_NEW_EMAIL = 'CONFIRM_NEW_EMAIL',
  RESET_PASSWORD_EMAIL = 'RESET_PASSWORD_EMAIL'
}
